import { FC } from "react";
import { ToastContainer, Slide } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "./ToastNotification.module.scss";

// Inner imports
import { TOAST_NOTIFICATIONS_LIMIT } from "./constants";

export const ToastNotification: FC = () => (
  <ToastContainer
    position="bottom-center"
    icon={false}
    closeButton={false}
    hideProgressBar
    limit={TOAST_NOTIFICATIONS_LIMIT}
    transition={Slide}
  />
);
